import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {DateAdapter, ErrorStateMatcher, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {Subscription} from 'rxjs';
import {SitePublicService} from 'src/app/services/site-public.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-statute-dialog',
  templateUrl: './statute-dialog.component.html',
  styleUrls: [ './statute-dialog.component.scss' ]
})

export class StatuteDialogComponent implements OnInit, OnDestroy {

  public Editor = ClassicEditor
  public matcher = new FormErrorStateMatcher(); // 
  public entityForm: FormGroup;
  public isEdit: boolean = false;

  public htmlContent: string = "";
  private formSubscription: Subscription | undefined;

  constructor (
    public matDialogRef: MatDialogRef<StatuteDialogComponent>,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // console.log("dialog data: " + JSON.stringify(this.data));
    this.entityForm = this.createForm(this.data)
    this.isEdit = this.data.id !== '0';

    //console.log(this.isEdit)
  }

  ngOnInit () {
    this._adapter.setLocale('pt');
    this.formSubscription = this.entityForm.controls.text.valueChanges.subscribe(value => {
      this.htmlContent = value;
    });

  }

  ngOnDestroy () {
    // Importante: Desinscreva-se para evitar vazamento de memória
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  createForm (data: any) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      position: new FormControl(data.position, [ Validators.required ]),
      date: new FormControl(data.date?.toDate() || null, [ Validators.required ]),
      title: new FormControl(data.title, [ Validators.required ]),
      text: new FormControl(data.text, [ Validators.required ])
    });

    this.htmlContent = data.text;

    return form
  }

}
